<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <h5 class="font-medium m-0">📄 Sale and Purchase of Fertilizers</h5>
                </div>
                <div class="card-body">
                    <!-- <div class="row align-items-end">
                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Block Office<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Financial/Reporting Year<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div>

                        <div class="col-lg-6 text-end">
                            <button type="button" class="btn btn-primary">Get Report</button>
                        </div>


                    </div> -->

                    <form [formGroup]="targetForm" (ngSubmit)="GetTFertilizerSalePurchase()">
                        <div class="row align-items-end">

                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                                <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                                    <option value="">--Select--</option>
                                    <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                                        {{ circle?.sCircleName }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                                    class="text-danger small">
                                    Circle office is required
                                </div>
                            </div>
                            <!-- Block Office -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="blockOffice">
                                    <option value="" selected>--Select--</option>
                                    <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                        {{ circle?.sBlockName }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                                    class="text-danger small">
                                    block Office is required
                                </div>
                            </div>

                            <!-- Financial Year -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Financial/Reporting Year <span
                                        class="text-danger">*</span></label>
                                <select class="form-control" formControlName="financialYear">
                                    <option value="">--Select--</option>
                                    <option *ngFor="let years of financialYears" [ngValue]="years">
                                        {{ years?.financialYear }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                                    class="text-danger small">
                                    Financial year is required
                                </div>
                            </div>

                            <!-- Submit -->
                            <div class="col-lg-12 text-end">
                                <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                                    Get Report
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <div class="d-flex align-items-center justify-content-between gap-1">
                        <h5 class="font-medium m-0">📄 Reports</h5>
                        <button type="button" class="btn btn-info btn-sm" data-bs-toggle="modal"
                            data-bs-target="#FertilizerSalePurchaseDataModal" (click)="addData()"
                            *ngIf="showButton && (this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)">Add
                            Data for, {{ currentMonth?.name}}</button>

                        <!-- Modal -->
                        <div class="modal fade" id="FertilizerSalePurchaseDataModal" data-bs-backdrop="static"
                            data-bs-keyboard="false" tabindex="-1"
                            aria-labelledby="FertilizerSalePurchaseDataModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl ">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h1 class="modal-title fs-5" id="FertilizerSalePurchaseDataModalLabel">
                                            Add/Update Fertilizer Sale/Purchase Data</h1>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            (click)="closeModel()" aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                        <form [formGroup]="fertilizerForm">
                                            <div class="row">

                                                <!-- <div class="col-lg-4 col-md-6 mb-2">
                                                <label class="form-label">Financial/Reporting Year<sup
                                                        class="text-danger">*</sup></label>
                                                <input type="text" class="form-control" value="2025-26" disabled />
                                            </div>

                                            <div class="col-lg-4 col-md-6 mb-2">
                                                <label class="form-label">Block Office<sup
                                                        class="text-danger">*</sup></label>
                                                <input type="text" class="form-control"
                                                    value="Shimla Urban - Block Office" disabled />
                                            </div>

                                            <div class="col-lg-4 col-md-6 mb-2">
                                                <label class="form-label">Data For Month<sup
                                                        class="text-danger">*</sup></label>
                                                <input type="text" class="form-control" value="June, 2025" disabled />
                                            </div> -->
                                                <!-- Financial Year -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">Financial/Reporting Year <span
                                                            class="text-danger">*</span></label>
                                                    <select class="form-control" formControlName="financialYear">
                                                        <option value="">--Select--</option>
                                                        <option *ngFor="let years of financialYears"
                                                            [ngValue]="years?.financialYear">
                                                            {{ years?.financialYear }}
                                                        </option>
                                                    </select>
                                                    <div *ngIf="fertilizerForm.get('financialYear')?.touched && fertilizerForm.get('financialYear')?.invalid"
                                                        class="text-danger small">
                                                        Financial year is required
                                                    </div>
                                                </div>


                                                <!-- Block Office -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">Block Office <span
                                                            class="text-danger">*</span></label>
                                                    <select class="form-control" formControlName="blockOffice">
                                                        <option value="" selected>--Select--</option>
                                                        <option *ngFor="let circle of blockList"
                                                            [value]="circle?.iBlockId">
                                                            {{ circle?.sBlockName }}
                                                        </option>
                                                    </select>
                                                    <div *ngIf="fertilizerForm.get('blockOffice')?.touched && fertilizerForm.get('blockOffice')?.invalid"
                                                        class="text-danger small">
                                                        block Office is required
                                                    </div>
                                                </div>


                                                <!-- During Month -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">During Month <span
                                                            class="text-danger">*</span></label>
                                                    <!-- <input class="form-control" type="month" formControlName="duringMonth" placeholder="e.g., May 2025" /> -->
                                                    <select class="form-control" formControlName="dataMonth">
                                                        <option value="" selected>--Select Month--</option>
                                                        <option *ngFor="let month of months" [value]="month?.iMonthId">
                                                            {{ month?.sMonthName }}
                                                        </option>
                                                    </select>

                                                    <div class="text-danger small" style="min-height: 1.25rem;">
                                                        <span
                                                            *ngIf="fertilizerForm.get('dataMonth')?.touched && fertilizerForm.get('dataMonth')?.invalid">
                                                            This field is required
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="col-lg-12">
                                                    <label class="form-label">Sale and Purchase Details<sup
                                                            class="text-danger">*</sup></label>

                                                    <div class="table-responsive">
                                                        <div formArrayName="fertilizerList">
                                                            <table class="table table-bordered table-hover">
                                                                <thead>
                                                                    <tr class="texture font-size-12">
                                                                        <th class="text-center" style="width: 2%"
                                                                            rowspan="2">S.No.
                                                                        </th>
                                                                        <th rowspan="2" style="width:15%">Kind of
                                                                            Fertilizer
                                                                        </th>
                                                                        <th class="text-center" colspan="2">Opening
                                                                            Stock as on
                                                                            01 June, 2025</th>
                                                                        <th class="text-center" colspan="2">Purchase
                                                                            during
                                                                            June, 2025</th>
                                                                        <th class="text-center" colspan="2">Sale during
                                                                            June,
                                                                            2025</th>
                                                                    </tr>
                                                                    <tr class="texture font-size-12">
                                                                        <th class="text-right" style="width:13%">Qty.
                                                                            (in MT)
                                                                        </th>
                                                                        <th class="text-right">Amt. (<i
                                                                                class="fa fa-inr fa-mr-0"></i> in lacs)
                                                                        </th>
                                                                        <th class="text-right" style="width:13%">Qty.
                                                                            (in MT)
                                                                        </th>
                                                                        <th class="text-right">Amt. (<i
                                                                                class="fa fa-inr fa-mr-0"></i> in lacs)
                                                                        </th>
                                                                        <th class="text-right" style="width:13%">Qty.
                                                                            (in MT)
                                                                        </th>
                                                                        <th class="text-right">Amt. (<i
                                                                                class="fa fa-inr fa-mr-0"></i> in lacs)
                                                                        </th>
                                                                    </tr>

                                                                </thead>
                                                                <tbody>
                                                                    <!-- <tr>
                                                                <td class="text-center">1.</td>
                                                                <td>
                                                                    Ammonium Sulphate
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td class="text-center">2.</td>
                                                                <td>
                                                                    DAP
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td class="text-center">3.</td>
                                                                <td>
                                                                    MOP 60%
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td class="text-center">4.</td>
                                                                <td>
                                                                    NPK (10:26:26)
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td class="text-center">5.</td>
                                                                <td>
                                                                    NPK (12:32:16)
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td class="text-center">6.</td>
                                                                <td>
                                                                    NPK (15:15:15)
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td class="text-center">7.</td>
                                                                <td>
                                                                    Others
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td class="text-center">8.</td>
                                                                <td>
                                                                    SSP
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td class="text-center">9.</td>
                                                                <td>
                                                                    Urea
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" />
                                                                        <span class="input-group-text">MT</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <span class="input-group-text">₹</span>
                                                                        <input type="text" class="form-control" />
                                                                    </div>
                                                                </td>
                                                            </tr> -->

                                                                    <tr *ngFor="let fertilizer of fertilizersFormArray.controls; let i = index"
                                                                        [formGroupName]="i">
                                                                        <td class="text-center">{{ i + 1 }}</td>
                                                                        <td>{{ fertilizer.get('kindOfFertilizer')?.value
                                                                            }}</td>

                                                                        <!-- Opening Qty -->
                                                                        <td>
                                                                            <div class="input-group">
                                                                                <input type="text" class="form-control"
                                                                                    formControlName="openingStockQty" />
                                                                                <span class="input-group-text">{{
                                                                                    fertilizer.get('unit')?.value
                                                                                    }}</span>
                                                                            </div>
                                                                            <div *ngIf="fertilizer.get('openingStockQty')?.touched && fertilizer.get('openingStockQty')?.invalid"
                                                                                class="text-danger small">
                                                                                Required & must be a valid number
                                                                            </div>
                                                                        </td>

                                                                        <!-- Opening Amt -->
                                                                        <td>
                                                                            <div class="input-group">
                                                                                <span class="input-group-text">₹</span>
                                                                                <input type="text" class="form-control"
                                                                                    formControlName="openingStockAmt" />
                                                                            </div>
                                                                            <div *ngIf="fertilizer.get('openingStockAmt')?.touched && fertilizer.get('openingStockAmt')?.invalid"
                                                                                class="text-danger small">
                                                                                Required & must be a valid amount
                                                                            </div>
                                                                        </td>

                                                                        <!-- Received Qty -->
                                                                        <td>
                                                                            <div class="input-group">
                                                                                <input type="text" class="form-control"
                                                                                    formControlName="purchaseQty" />
                                                                                <span class="input-group-text">{{
                                                                                    fertilizer.get('unit')?.value
                                                                                    }}</span>
                                                                            </div>
                                                                            <div *ngIf="fertilizer.get('purchaseQty')?.touched && fertilizer.get('purchaseQty')?.invalid"
                                                                                class="text-danger small">
                                                                                Required & must be a valid number
                                                                            </div>
                                                                        </td>

                                                                        <!-- Received Amt -->
                                                                        <td>
                                                                            <div class="input-group">
                                                                                <span class="input-group-text">₹</span>
                                                                                <input type="text" class="form-control"
                                                                                    formControlName="purchaseAmt" />
                                                                            </div>
                                                                            <div *ngIf="fertilizer.get('purchaseAmt')?.touched && fertilizer.get('purchaseAmt')?.invalid"
                                                                                class="text-danger small">
                                                                                Required & must be a valid amount
                                                                            </div>
                                                                        </td>

                                                                        <!-- Distributed Qty -->
                                                                        <td>
                                                                            <div class="input-group">
                                                                                <input type="text" class="form-control"
                                                                                    formControlName="saleQty" />
                                                                                <span class="input-group-text">{{
                                                                                    fertilizer.get('unit')?.value
                                                                                    }}</span>
                                                                            </div>
                                                                            <div *ngIf="fertilizer.get('saleQty')?.touched && fertilizer.get('saleQty')?.invalid"
                                                                                class="text-danger small">
                                                                                Required & must be a valid number
                                                                            </div>
                                                                        </td>

                                                                        <!-- Distributed Amt -->
                                                                        <td>
                                                                            <div class="input-group">
                                                                                <span class="input-group-text">₹</span>
                                                                                <input type="text" class="form-control"
                                                                                    formControlName="saleAmt" />
                                                                            </div>
                                                                            <div *ngIf="fertilizer.get('saleAmt')?.touched && fertilizer.get('saleAmt')?.invalid"
                                                                                class="text-danger small">
                                                                                Required & must be a valid amount
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                </div>



                                            </div>

                                        </form>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="closeModel()">Close</button>
                                        <button type="button" class="btn btn-primary" (click)="onSubmit()">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">

                        <!-- 
                        <table class="table table-bordered table-hover">
                            <thead>

                                <tr>
                                    <th class="text-center" style="width: 3%" rowspan="2">#</th>
                                    <th rowspan="2">Month</th>
                                    <th rowspan="2">Kind of Fertilizer</th>
                                    <th class="text-center" colspan="2">Opening Stock at the begining of month</th>
                                    <th class="text-center" colspan="2">Purchase during the month</th>
                                    <th class="text-center" colspan="2">Sale during the month</th>
                                    <th class="text-center">Balance</th>
                                    <th rowspan="2" class="text-center" style="width:3%">Action</th>
                                </tr>
                                <tr>
                                    <th class="text-right" style="width:8%">Qty. (in MT) </th>
                                    <th class="text-right" style="width:9%">Amt. (<i class="fa fa-inr fa-mr-0"></i> in
                                        lacs)</th>
                                    <th class="text-right" style="width:8%">Qty. (in MT) </th>
                                    <th class="text-right" style="width:9%">Amt. (<i class="fa fa-inr fa-mr-0"></i> in
                                        lacs)</th>
                                    <th class="text-right" style="width:8%">Qty. (in MT) </th>
                                    <th class="text-right" style="width:9%">Amt. (<i class="fa fa-inr fa-mr-0"></i> in
                                        lacs)</th>
                                    <th class="text-right" style="width:8%">Qty. (in MT) </th>

                                </tr>

                            </thead>
                            <tbody>
                                <tr>
                                    <td rowspan="9" class="text-center">1.</td>
                                    <td rowspan="9">April, 2025</td>
                                    <td>Ammonium Sulphate</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>

                                    <td rowspan="9" class="text-center no-wrap">
                                        <button type="button" class="btn btn-primary btn-sm"
                                            title="Verified on 05/02/2025 04:25:00 PM"><i
                                                class="bi bi-lock"></i></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>DAP</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>

                                </tr>
                                <tr>
                                    <td>MOP 60%</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>

                                </tr>
                                <tr>
                                    <td>NPK (10:26:26)</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>

                                </tr>
                                <tr>
                                    <td>NPK (12:32:16)</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>

                                </tr>
                                <tr>
                                    <td>NPK (15:15:15)</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>

                                </tr>
                                <tr>
                                    <td>Others</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>

                                </tr>
                                <tr>
                                    <td>SSP</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>

                                </tr>
                                <tr>
                                    <td>Urea</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">360.00</td>
                                    <td class="text-right">108000.00</td>
                                    <td class="text-right">170.00</td>
                                    <td class="text-right">47600.00</td>
                                    <td class="text-right">190.00</td>

                                </tr>





                            </tbody>
                        </table> -->
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 3%" rowspan="2">S.No.</th>
                                    <th rowspan="2">Month</th>
                                    <th rowspan="2">Kind of Fertilizer</th>
                                    <th class="text-center" colspan="2">Opening Stock at the beginning of month</th>
                                    <th class="text-center" colspan="2">Purchase during the month</th>
                                    <th class="text-center" colspan="2">Sale during the month</th>
                                    <th class="text-center" colspan="2">Balance</th>
                                    <th rowspan="2" class="text-center" style="width:3%">Action</th>
                                </tr>
                                <tr>
                                    <th class="text-right">Qty. (in MT)</th>
                                    <th class="text-right">Amt. (<i class="fa fa-inr fa-mr-0"></i> in lacs)</th>
                                    <th class="text-right">Qty. (in MT)</th>
                                    <th class="text-right">Amt. (<i class="fa fa-inr fa-mr-0"></i> in lacs)</th>
                                    <th class="text-right">Qty. (in MT)</th>
                                    <th class="text-right">Amt. (<i class="fa fa-inr fa-mr-0"></i> in lacs)</th>
                                    <th class="text-right">Qty. (in MT)</th>
                                    <th class="text-right">Amt. (<i class="fa fa-inr fa-mr-0"></i> in lacs)</th>

                                </tr>
                            </thead>

                            <tbody>
                                <ng-container *ngFor="let group of groupedData; let monthIndex = index">
                                    <ng-container *ngFor="let fert of group.fertilizers; let i = index">
                                        <tr>
                                            <!-- Only show row number & month name in the first row -->
                                            <td *ngIf="i === 0" [attr.rowspan]="group.fertilizers.length"
                                                class="text-center">
                                                {{ monthIndex + 1 }}.
                                            </td>
                                            <td *ngIf="i === 0" [attr.rowspan]="group.fertilizers.length">
                                                {{ group.monthName }}
                                            </td>

                                            <td>{{ fert.kindOfFertilizer }}</td>
                                            <td class="text-right">{{ fert.openingStockQty || 0 | number:'1.2-2' }}</td>
                                            <td class="text-right">{{ fert.openingStockAmt || 0 | number:'1.2-2' }}</td>
                                            <td class="text-right">{{ fert.purchaseQty || 0 | number:'1.2-2' }}</td>
                                            <td class="text-right">{{ fert.purchaseAmt || 0 | number:'1.2-2' }}</td>
                                            <td class="text-right">{{ fert.saleQty || 0 | number:'1.2-2' }}</td>
                                            <td class="text-right">{{ fert.saleAmt || 0 | number:'1.2-2' }}</td>
                                            <td class="text-right">
                                                {{ (fert.openingStockQty + fert.purchaseQty - fert.saleQty) || 0 |
                                                number:'1.2-2' }}
                                            </td>
                                            <td class="text-right">
                                                {{ (fert.openingStockAmt + fert.purchaseAmt - fert.saleAmt) || 0 |
                                                number:'1.2-2' }}
                                            </td>

                                            <!-- Action button in last column, only once per month -->
                                            <td *ngIf="i === 0" [attr.rowspan]="group.fertilizers.length"
                                                class="text-center no-wrap">
                                                <ng-container
                                                    *ngIf="!fert.isVerified && (UserDetails?.roleId == 11 || UserDetails?.roleId == 13); else verifiedBlock">
                                                    <button type="button" class="btn btn-primary btn-sm"
                                                        title="Click to Edit" (click)="editRow(group)">
                                                        <i class="bi bi-pencil-square"></i>
                                                    </button> &nbsp;
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        title="Click to Verify" *ngIf="this.UserDetails?.roleId ==13"
                                                        data-bs-toggle="modal" data-bs-target="#verifyConfirmModal"
                                                        (click)="setDeleteIndex(group)">
                                                        <i class="bi bi-clipboard2-check"></i>
                                                    </button>&nbsp;
                                                    <button type="button" class="btn btn-danger btn-sm"
                                                        title="Click to Delete" data-bs-toggle="modal"
                                                        data-bs-target="#deleteConfirmModal"
                                                        (click)="setDeleteIndex(group)">
                                                        <i class="bi bi-trash3"></i>
                                                    </button>
                                                </ng-container>
                                                <ng-template #verifiedBlock>
                                                    <button type="button" class="btn btn-primary btn-sm"
                                                        title="Verified">
                                                        <i class="bi bi-lock"></i>
                                                    </button>
                                                </ng-template>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                        <!-- Delete Confirmation Modal -->
                        <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                            aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to delete ?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="cancelDelete()">Cancel</button>
                                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="DeleteTFertilizerSalePurchase(deleteRow)">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- verify Confirmation Modal -->
                        <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                            aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to Verify?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="this.deleteRow = {};">Cancel</button>
                                        <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="verifyFertilizerSalePurchase(deleteRow)">Verify</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


    </div>
</div>